// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3m11E","inputWrap":"CustomTip_inputWrap__3i7eR"};